
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

import { Link } from "react-router-dom";
import roman from "../../assets/roman.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function RomanMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Román magyar fordító</title>
                <meta name='description' content="Ingyenes román magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Román magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/roman-magyar-fordito" />
            </Helmet>
            <h1>Román magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A Román nyelvről</h2>
                    <img src={roman} alt="Román zászló"></img>
                </div>
                <p>A román egy neo-latin nyelv, amelyet körülbelül 24 millió ember beszél, elsősorban Romániában és Moldovában. A világ román közösségei is beszélik. A román latin gyökereiről, egyedi hangzási sajátosságairól, valamint a Balkánhoz és Kelet-Európához fűződő kulturális kapcsolatairól ismert.</p>

                <p>Írásrendszere a latin ábécét használja néhány további diakritikus jellel. 31 betűből áll, beleértve az olyan speciális karaktereket, mint az ă, â, î, ş és ţ. A román kiejtése általában fonetikus, a helyesírás és a hang között szoros összefüggés van. Egyedülálló tulajdonsággal rendelkezik, az úgynevezett "palatalizáció", ahol bizonyos mássalhangzókat lágy, palatális hanggal ejtenek ki.</p>

                <p>Nyelvtana hasonlóságokat mutat más román nyelvekkel. Vannak benne főnévi ragozások, igeragozások és nyelvtani nemek. A főnevek és melléknevek alakja kisbetű, nem és szám szerint változik. A román nyelvnek három nyelvtani neme van (férfi, nőnemű és semleges), és megtartja az öt esetből álló rendszert (nominatívus, accusative, genitivus, datative és vocative).</p>

                <p>A román szókincs latin eredetű, de más nyelvekből, különösen szlávból, törökből és franciából származó kölcsönszavakat is tartalmaz. A román irodalom gazdag hagyományokkal rendelkezik, olyan neves szerzőkkel, mint Mihai Eminescu, Mircea Eliade és Eugène Ionesco. A román néphagyományok, a zene és a konyha fontos részei a kulturális örökségnek.</p>

                <p>A román kultúra sokszínű, történelme és földrajzi elhelyezkedése befolyásolja. A román nyelv tanulása betekintést nyújt az ország történelmébe, hagyományaiba és társadalmi normáiba. Ezenkívül elősegíti a román társadalom mélyebb megértését, és elősegíti a kapcsolatokat a román nyelvű közösségekkel.</p>

                <p>A román nyelvtudás lehetőségeket nyithat meg Romániában, Moldovában és más román nyelvű régiókban. Románia fejlődő gazdasággal rendelkezik, és lehetőséget kínál az üzleti élet, a kereskedelem és a turizmus számára. A román nyelv ismerete előnyös lehet olyan iparágakban, mint a technológia, a pénzügy, a turizmus és a fordítás.</p>

                <p>A román nyelv a kelet-európai kulturális felfedezésekhez és utazásokhoz is hasznos. Lehetővé teszi a kommunikációt és a kulturális elmélyülést a román nyelvű közösségekben, és elősegíti a kapcsolatokat a szomszédos országokkal, például Bulgáriával és Szerbiával.</p>
        
                <div className="sectionbottom">
                    <Link to="/magyar-roman-fordito">Magyar román fordító</Link>

                    <img src={roman} alt="román zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
        
            </section>
        </>

    )
}

export default RomanMagyar;